<template>
    <div class="relative">
        <BaseButton
            data-action="ai-integration"
            :data-float-label="localizations[lang].new"
            icon-custom-fill="#FF26E9"
            icon="sparkles"
            :disabled="isOffline"
            :tooltip="localizations[lang].tooltips.aiIntegrations"
            :btn-text="btnText"
            @click="handleMainButtonClick"
        >
        </BaseButton>
        <transition name="slide-fade">
            <ComponentTooltip v-show="showTooltipWarn" :allow-wrap="true">
                <div class="w-full text-center" style="white-space: pre-line">{{ errorMessage }}</div>
            </ComponentTooltip>
        </transition>
        <transition name="slide-fade">
            <ListDropdown
                v-show="menuAiIsShowing"
                class="text-theme-toolbar-icon"
                :submenu-display-in-down="submenuDisplayInDown"
            >
                <ListItemButton
                    v-for="(actionText, action) in aiActions"
                    :key="action"
                    class="text-theme-toolbar-icon"
                    @click="showAiIntegration(action)"
                >
                    <svg-icon :icon="`${action}-text`" width="20px" height="20px"></svg-icon>
                    <span class="ml-3">{{ actionText }} </span>
                </ListItemButton>
            </ListDropdown>
        </transition>
    </div>
</template>
<script>
import ComponentTooltip from '_shared_/UI/Components/ComponentTooltip.vue';
import ListDropdown from '../../Components/list/ListDropdown.vue';
import ListItemButton from '../../Components/list/ListItemButton.vue';
import { mapState } from 'vuex';
import BaseButton from '../../Components/buttons/BaseButton.vue';
import {
    AI_MAX_CHARACTERS,
    AI_MIN_CHARACTERS,
    TOOLTIP_AUTO_HIDE_DURATION,
} from '_shared_/js/constants/readerSelectionToolLimits.js';

export default {
    components: {
        ComponentTooltip,
        BaseButton,
        ListDropdown,
        ListItemButton,
    },
    props: {
        showAiIntegration: {
            type: Function,
            required: true,
        },
        toggleAIMenu: {
            type: Function,
            required: true,
        },
        menuAiIsShowing: {
            type: Boolean,
            required: true,
        },
        submenuDisplayInDown: {
            type: Boolean,
            required: true,
        },
        btnText: {
            type: String,
            required: false,
            default: null,
        },
        isDesktop: {
            type: Boolean,
            required: true,
        },
        openToast: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            minLengthSelectedTextForAI: AI_MIN_CHARACTERS,
            maxLengthSelectedTextForAI: AI_MAX_CHARACTERS,
            showTooltipWarn: false,
        };
    },
    computed: {
        ...mapState(['ui', 'localizations', 'currentHighlight', 'lang', 'aiActions', 'isOffline']),
        iconColorStyle() {
            return {
                color: this.currentHighlight.color ? this.currentHighlight.color : 'transparent',
            };
        },
        isValid() {
            const charCount = this.currentHighlight.totalText.length;
            return charCount >= this.minLengthSelectedTextForAI && charCount <= this.maxLengthSelectedTextForAI;
        },
        charCount() {
            return this.currentHighlight.totalText.length;
        },
        errorMessage() {
            return this.localizations[this.lang].aiValidation.message
                .replace('{count}', this.charCount)
                .replace('{min}', this.minLengthSelectedTextForAI)
                .replace(/{max}/g, this.maxLengthSelectedTextForAI);
        },
    },
    methods: {
        colorClasses(color) {
            return {
                'relative transition-transform duration-50 ease-in': this.currentHighlight.color === color.code,
                "after:content-[''] after:absolute after:w-[26px] after:h-[26px] after:border after:border-solid after:border-2 after:border-current after:rounded-full after:scale-120":
                    this.currentHighlight.color === color.code,
            };
        },
        handleMainButtonClick() {
            if (!this.isValid) {
                if (!this.showTooltipWarn && this.isDesktop) {
                    this.showTooltipWarn = true;
                    setTimeout(() => (this.showTooltipWarn = false), TOOLTIP_AUTO_HIDE_DURATION);
                } else if (!this.isDesktop) {
                    this.openToast({ text: this.errorMessage });
                }
                return;
            }
            this.toggleAIMenu();
        },
    },
};
</script>
